import { render, staticRenderFns } from "./EnrollExamEmbaStudentResultDesc.vue?vue&type=template&id=4ae8567c&scoped=true"
import script from "./EnrollExamEmbaStudentResultDesc.vue?vue&type=script&lang=js"
export * from "./EnrollExamEmbaStudentResultDesc.vue?vue&type=script&lang=js"
import style0 from "./EnrollExamEmbaStudentResultDesc.vue?vue&type=style&index=0&id=4ae8567c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8567c",
  null
  
)

export default component.exports